import React from 'react';
import './ReservationBanner.css';

import reservationBanner from "../../../../assets/rsto/d-two/reservationpic.png";

const ReservationBanner = () => {
    return (
        <>
            <div className="row gx-0 d-flex justify-content-center align-items-center">
                <div className="col-12 d-flex justify-content-center align-items-center reservation-banner-bg">
                    <div className="reservation-banner-background-overlay"></div>
                    <h3 className="reservation-banner-text text-white" style={{fontSize: "4rem"}}>Réservation</h3>
                    <img src={reservationBanner} alt="reservation-banner" className="img-fluid" />
                </div>
              
        
            </div>
        </>
    );
};

export default ReservationBanner;